export const heroContent = {
  title: '喑网91',
  subtitle: '值得信赖的综合网络平台',
  description: '喑网91为您提供全方位网络服务体验，集成核心功能模块与智能操作流程，让每一位用户都能轻松享受高效、安全、便捷的在线服务。',
  ctaPrimary: '立即探索',
  ctaSecondary: '了解更多',
};

export const features = [
  {
    icon: 'ri-shield-check-line',
    title: '安全保障',
    description: '喑网91采用多层安全防护机制，全方位保障用户数据安全与隐私，让您使用更放心。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '高效便捷',
    description: '喑网91优化操作流程，精简交互步骤，让您快速完成目标操作，提升使用效率。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    description: '喑网91支持桌面端与移动端无缝切换，随时随地享受一致的优质服务体验。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '贴心服务',
    description: '喑网91提供全天候客户支持，快速响应您的需求，让服务体验更加贴心周到。',
  },
  {
    icon: 'ri-rocket-2-line',
    title: '持续更新',
    description: '喑网91团队持续迭代优化，定期推出新功能与体验改进，保持平台活力。',
  },
  {
    icon: 'ri-group-line',
    title: '社区共建',
    description: '喑网91拥有活跃的用户社区，交流分享使用心得，共同推动平台不断进步。',
  },
];

export const advantages = [
  {
    title: '专业团队',
    description: '喑网91由资深技术团队打造，拥有多年行业经验，确保平台稳定可靠运行。',
    stat: '10+',
    statLabel: '年行业经验',
    icon: 'ri-team-line',
  },
  {
    title: '海量用户',
    description: '喑网91已服务数百万用户，覆盖全国各大城市，赢得广泛信赖与好评。',
    stat: '500万+',
    statLabel: '累计用户',
    icon: 'ri-user-heart-line',
  },
  {
    title: '技术领先',
    description: '喑网91采用前沿技术架构，保障系统高性能与高可用性，持续引领行业发展。',
    stat: '99.9%',
    statLabel: '服务可用率',
    icon: 'ri-cpu-line',
  },
  {
    title: '全面覆盖',
    description: '喑网91功能矩阵覆盖多个服务领域，一站式满足您的多元化网络需求。',
    stat: '50+',
    statLabel: '功能模块',
    icon: 'ri-apps-2-line',
  },
];

export const highlights = [
  {
    title: '智能匹配',
    description: '喑网91智能算法精准匹配您的需求，推荐最适合的服务内容与功能模块。',
    imageSeq: 'highlight-01',
    imageQuery: 'Modern%20digital%20abstract%20geometric%20pattern%20with%20warm%20amber%20and%20cream%20tones%2C%20clean%20minimal%20composition%2C%20soft%20gradient%20texture%2C%20elegant%20flowing%20lines%2C%20professional%20technology%20aesthetic%2C%20subtle%20light%20effects%2C%20peaceful%20atmosphere',
  },
  {
    title: '数据分析',
    description: '喑网91提供详尽的数据分析面板，帮助您清晰了解使用情况，做出更明智的决策。',
    imageSeq: 'highlight-02',
    imageQuery: 'Abstract%20data%20visualization%20with%20warm%20coral%20and%20cream%20gradients%2C%20minimal%20geometric%20shapes%2C%20soft%20ambient%20light%2C%20clean%20professional%20design%2C%20flowing%20organic%20forms%2C%20elegant%20modern%20aesthetic%2C%20subtle%20texture%20background',
  },
  {
    title: '个性定制',
    description: '喑网91支持个性化界面定制，根据您的偏好调整布局与功能，打造专属使用体验。',
    imageSeq: 'highlight-03',
    imageQuery: 'Customizable%20digital%20interface%20concept%20with%20warm%20terracotta%20and%20cream%20color%20palette%2C%20modular%20design%20elements%2C%20soft%20abstract%20background%2C%20clean%20minimal%20style%2C%20professional%20atmosphere%2C%20elegant%20flowing%20composition',
  },
];

export const faqItems = [
  {
    question: '喑网91是什么平台？',
    answer: '喑网91是一个综合性的网络服务平台，集成了多种实用功能模块，为用户提供安全、高效、便捷的在线服务体验。无论您是个人用户还是企业客户，都能在喑网91找到适合的服务内容。',
  },
  {
    question: '如何使用喑网91的各项功能？',
    answer: '您可以通过喑网91官网首页快速入口访问各功能模块，平台提供详细的使用指南和操作教程。首次使用建议浏览"使用指南"板块，了解各功能的基本操作流程。如有疑问，可随时联系客服获取帮助。',
  },
  {
    question: '喑网91的服务是否免费？',
    answer: '喑网91提供基础功能的免费使用，部分高级功能可能需要订阅或付费。具体收费标准请查看各功能模块的详细说明，平台承诺价格透明、无隐藏费用。',
  },
  {
    question: '喑网91如何保障用户数据安全？',
    answer: '喑网91采用行业领先的加密技术和安全防护体系，严格遵守数据保护相关法律法规。平台定期进行安全审计和漏洞扫描，确保用户数据得到最高级别的保护。',
  },
  {
    question: '喑网91支持哪些设备和系统？',
    answer: '喑网91全面支持主流操作系统和浏览器，包括Windows、macOS、iOS、Android等平台。您可以通过电脑浏览器或移动设备访问，获得一致的使用体验。',
  },
  {
    question: '如何获取喑网91的最新版本信息？',
    answer: '喑网91会定期通过官网公告、邮件通知和站内消息推送版本更新信息。您也可以关注喑网91官方社交媒体账号，第一时间获取最新动态和功能更新资讯。',
  },
];

export const testimonials = [
  {
    name: '张先生',
    role: '资深用户',
    content: '使用喑网91已经三年了，平台功能越来越完善，操作体验也非常流畅。喑网91是我最信赖的网络平台，推荐给身边很多朋友。',
    rating: 5,
  },
  {
    name: '李女士',
    role: '企业用户',
    content: '喑网91帮助我们企业提升了大量效率，数据分析功能特别实用。客服响应也很及时，问题都能快速得到解决。',
    rating: 5,
  },
  {
    name: '王同学',
    role: '个人用户',
    content: '作为新用户，喑网91的使用指南非常清晰易懂，很快就上手了。平台的界面设计也很美观，使用起来很舒服。',
    rating: 4,
  },
];